<div [class]="DRAG_AND_DROP_GRID_BOUNDARY"
  cdkDropListGroup
  [cdkDropListGroupDisabled]="disableDropGroup()">

  <!-- Add new item button -->
  @if (hasAddButton) {
    <button
      class="btn-primary"
      [attr.data-cy]="addButtonDataCy"
    (click)="clickOnAddButton()">Add {{buttonLabelArticle}} {{addButtonLabel}}</button>
  }

  <!-- Drag placeholder element -->
  <div cdkDropList
    class="drag-and-drop-grid-placeholder"
    [cdkDropListEnterPredicate]="dropListEnterPredicate"
  (cdkDropListDropped)="dropListDropped()"></div>

  <!-- Items list -->
  @for (item of items; track trackItem($index, item)) {
    <div cdkDropList
      [cdkDropListEnterPredicate]="dropListEnterPredicate"
      [cdkDropListConnectedTo]="dragAndDropGridConnectedTo"
      [cdkDropListData]="items"
      (cdkDropListDropped)="dropListDropped()">
      <div cdkDrag
        [cdkDragDisabled]="$safeNavigationMigration(item?.disableDrag)"
        (cdkDragMoved)="dragMoved($event)"
        (cdkDragDropped)="onDragDropped($event)"
        [cdkDragData]="$safeNavigationMigration(item?.data)"
        [cdkDragBoundary]="getDragItemBoundary(item)">
        <ng-container *ngTemplateOutlet="itemsTemplate; context: {item: $safeNavigationMigration(item?.data)}"></ng-container>
      </div>
    </div>
  }
</div>

